import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { NEUTRAL_300, BLACK, GRAYSCALE_400, DARK_VIOLET } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 16px;
  gap: 24px;
`

export const ProviderSection = styled.div`
  width: 100%;
`

export const AmountSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
`

export const AmountLabel = styled.div`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${GRAYSCALE_400};
`

export const AmountValue = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 24px;
  color: ${DARK_VIOLET};
`

export const ButtonWrapper = styled.div`
  padding: 16px;
  background-color: white;
  padding-bottom: 32px;
`
